var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"alert",class:_vm.alertClass,attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-message"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"alert-close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.handleClose}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }